import { Container, Spacer, Text } from '@mariozechner/pi-tui';
import packageJson from '../../package.json';
import { getModelDisplayName } from '../utils/model.js';
import { theme } from '../theme.js';

const INTRO_WIDTH = 50;

export class IntroComponent extends Container {
  private readonly modelText: Text;

  constructor(model: string | null) {
    super();

    const welcomeText = 'Welcome to Max';
    const versionText = ` v${packageJson.version}`;
    const fullText = welcomeText + versionText;
    const padding = Math.floor((INTRO_WIDTH - fullText.length - 2) / 2);
    const trailing = INTRO_WIDTH - fullText.length - padding - 2;

    this.addChild(new Spacer(1));
    this.addChild(new Text(theme.primary('═'.repeat(INTRO_WIDTH)), 0, 0));
    this.addChild(
      new Text(
        theme.primary(
          `║${' '.repeat(padding)}${theme.bold(welcomeText)}${theme.muted(versionText)}${' '.repeat(
            trailing,
          )}║`,
        ),
        0,
        0,
      ),
    );
    this.addChild(new Text(theme.primary('═'.repeat(INTRO_WIDTH)), 0, 0));
    this.addChild(new Spacer(1));

    this.addChild(
      new Text(
        theme.bold(
          theme.primary(
            `
	███╗   ███╗ █████╗ ██╗  ██╗
	████╗ ████║██╔══██╗╚██╗██╔╝
	██╔████╔██║███████║ ╚███╔╝ 
	██║╚██╔╝██║██╔══██║ ██╔██╗ 
	██║ ╚═╝ ██║██║  ██║██╔╝ ██╗
	╚═╝     ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝`,
          ),
        ),
        0,
        0,
      ),
    );

    this.addChild(new Spacer(1));
    this.addChild(new Text(theme.bold('Your AI assistant for deep financial research on Indian stocks'), 0, 0));
    this.addChild(new Spacer(1));
    this.addChild(new Text('Type /help to get started.', 0, 0));
    this.modelText = new Text('', 0, 0);
    this.addChild(this.modelText);
    this.setModel(model);
  }

  setModel(model: string | null) {
    if (!model) {
      this.modelText.setText(
        `${theme.muted('Model: ')}${theme.warning('No model selected')} ${theme.muted('• /model to choose')}`,
      );
      return;
    }

    this.modelText.setText(
      `${theme.muted('Model: ')}${theme.primary(getModelDisplayName(model))} ${theme.muted('• /model to switch')}`,
    );
  }
}
